<template>
    <div class='bg-light' v-if="device">
        <table class="table table-responsive-sm table-striped py-4">
            <tr>
                <th colspan="4"><span v-if="device">{{$t('share_access_device')}} {{device.name}}</span></th>
            </tr>
            <tr>
                <td colspan="4">{{$t('link_public_desc')}}</td>
            </tr>
            <tr v-if="pub_links.length">
                <th>{{$t('created')}}</th>
                <th>Expiration</th>
                <th colspan="2">{{$t('public_link')}}</th>
                <th></th>
            </tr>
            <tr v-for="pub_link in pub_links" :key="pub_link.uuid">
                <td>{{pub_link.created | formatDate}}</td>
                <td>{{pub_link.expiration_date | formatDate}}</td>
                <td>
                    <button class="btn btn-sm btn-secondary" v-on:click="copy_to_clipboard(pub_link.uuid)"><span
                            data-feather="copy"></span></button>
                </td>
                <td>
                    <div :id="pub_link.uuid">{{pub_link|fullURL}}</div>
                </td>
                <td>
                    <button class="btn btn-sm btn-danger" v-on:click="on_delete(pub_link)"><span
                            data-feather="trash"></span></button>
                </td>
            </tr>
        </table>
        <table class="table table-responsive-sm table-striped" v-if="allow_edit">
            <tr>
                <th>{{$t('create_public_link')}}</th>
            </tr>
            <tr>
                <td class="col-6">
                    <multiselect
                            v-model="new_pub_link.duration"
                            :value=12
                            :options="duration_options"
                            :multiple="false"
                            :close-on-select="true"
                            :hide-selected="true"
                            :preserve-search="true"
                            :custom-label="duration_label"
                            :placeholder="$t('select_duration_link')"
                            :select-label="$t('select')"
                            :selected-label="$t('selected')"
                            :deselect-label="$t('deselect_label')"
                    >
                    </multiselect>
                </td>
                <td class="col-6">
                    <button class="btn btn-sm btn-primary" v-on:click="create_pub_link()">{{$t('create_link')}}
                    </button>
                </td>
            </tr>
        </table>
      <div class="py-4 m-4">
        <p>{{$t('generate_police_report')}}</p>
        <button class="btn btn-primary" v-on:click="getReport">{{$t('export')}}</button>
      </div>
    </div>
</template>

<script>
import * as nvxlib from '../nvxcommon'
import {bus} from '../event-bus'
import {HTTP} from '../http-constants'
import Multiselect from 'vue-multiselect'
import Vue from 'vue'

const feather = require('feather-icons')

Vue.filter('fullURL', function (value) {
        var base_url = window.location.origin
        const _url = base_url + "/tracker_pub.html?token=" + value.uuid;
        return _url;
    });

    export default {
        name: 'TrackerPanelShare',
        components: { multiselect: Multiselect },
        data: function () {
            return {
                device: null,
                pub_links: [],
                allow_edit: false,
                duration_options: [1, 6, 12, 24, 168, 240],
                new_pub_link: {'duration': 24},
                fileReport: null
            }
        },
      methods: {
        async shareFile() {
          if (this.isChromeDesktop()) {
            console.log("Chrome Desktop detected - Forcing file download.");
            this.downloadFile();
            return;
          }
          if (navigator.share && navigator.canShare && navigator.canShare({files: [this.fileReport]})) {
            try {
              await navigator.share({
                files: [this.fileReport],
                title: this.fileReport.name,
              });
              console.log("Partage réussi !");
            } catch (err) {
              console.error("Erreur lors du partage", err);
            }
          } else {
            this.downloadFile(); // Si partage impossible, on télécharge
          }
        },
        isChromeDesktop() {
          const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
          const isMobile = /Mobi|Android/i.test(navigator.userAgent);
          return isChrome && !isMobile; // True for Chrome Desktop, false for mobile
        },
        downloadFile() {
          const fileURL = URL.createObjectURL(this.fileReport);
          const a = document.createElement("a");
          a.href = fileURL;
          a.download = this.fileReport.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(fileURL);
        },

        getReport: function () {
          nvxlib.getTheftForms(this.device, re => {
            let fileName = 'report_' + this.device.serial.slice(-6) + '.pdf';
            const blob = new Blob([re.data], {type: "application/pdf"});
            console.log("filename", fileName);
            console.log("blob", blob);
            this.fileReport = new File([blob], fileName, {type: 'application/pdf'});
            this.shareFile();
          })

        },
            'get_public_links': function () {
                var self = this;
                HTTP.get("/devices/" + this.device.id + "/public_share_link/", this.device)
                    .then(function (re) {
                        self.pub_links = re.data;
                        console.log(self.pub_links)
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            'create_pub_link': function () {

                var self = this;

                HTTP.post("/devices/" + this.device.id + "/public_share_link/", self.new_pub_link)
                    .then(function (re) {
                        var new_pub_link = re.data;
                        self.pub_links.push(new_pub_link);
                        self.new_pub_link = {};
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            'on_delete': function (pub_link) {
                var self = this;
                HTTP.delete("/tracker_public_share_links/" + pub_link.uuid + "/")
                    .then(function (re) {
                        console.log('delte')
                        var idx = self.pub_links.indexOf(pub_link);
                        if (idx >= 0) {
                            self.pub_links.splice(idx, 1);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
            'duration_label': function (option) {
                if (option == 1) {
                    return "1 " + app.$t('hour');
                } else if (option < 24) {
                    return `${option} ` + app.$t('hours')
                } else if (option == 24) {
                    return "1 " + app.$t('day');
                } else {
                    const days = option / 24;
                    //const hours = option % 24;
                    return `${days} ` + app.$t('days')
                }
            },
            'copy_to_clipboard': function (id) {
                var fullUrl = document.getElementById(id);

                var range = document.createRange();
                range.selectNode(fullUrl);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                document.execCommand("copy");
                window.getSelection().removeAllRanges();
            }

        },
        mounted: function () {
            var self = this;
            nvxlib.getUserRole(function (role) {
                if (role != 'sub_user') {
                    self.allow_edit = true;
                }
            });
        },
        created: function () {
            bus.$on('tracker_panel', elem => {
                var action = elem.action;
                if (action == 'share') {
                    this.device = elem.tracker;
                    if (this.device) {
                        this.get_public_links();
                    }
                } else {
                    this.device = null;
                }
            });
        },
        updated: function () {
            feather.replace();
        }
    }
</script>